module.exports = __webpack_public_path__ + "img/Nadia_Suttle.96a05826.png";